import React, {Component} from 'react';
import {connect} from 'react-redux'
import {Dialog, Flex, FlexItem, FormCell, CellHeader, Checkbox, CellBody, Form} from 'react-weui'
import {WKOwnDialog} from '../wk'
import qr from 'qr-encode'
import axios from 'axios'
import EventBus from '../../utils/bus'

import '../../styles/classroom/ClassroomCountDown.css'


class ClassroomCountDown extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isSubscribedTOtherAccount: false,
            isLectureSubscribed: true,
            started: false,
            show: false,
            init: false,
            buttons: [{
                label: '知道了',
                onClick: this.hide.bind(this)
            }],
            countdown: {},

            deepperFocusQrcode: null,
        }
        this.handleToggleSubscribed  = this.handleToggleSubscribed.bind(this)
    }

    componentDidMount() {
        if (!this.props.account.subscribed){
            try {
                EventBus.on('subscribed_retainInfo', (subscribed_retainIn) => {
                    const subscribed_retain = subscribed_retainIn
                    this.setState({
                        isSubscribedTOtherAccount: subscribed_retain,
                        init: true
                    })
                    if (!subscribed_retain) {
                        const {lecture} = this.props
                        const tsNow = parseInt(Date.now() / 1000, 10)
            
                        if (lecture.start_timestamp > tsNow){
                            axios.get(`/api/liveroom/${this.props.liveroom.id}/get_qrcode`, {
                                params: {
                                    object_id: this.props.lecture.id,
                                    object_type: 'lecture'
                                }
                            })
                                .then(res => {
                                    if (res.data.code === 0) {
                                        this.setState({
                                            deepperFocusQrcode: res.data.data.qrcode_content
                                        })
                                    }
                                })
                        }
                    }
                })
            }catch (error) {
                console.log('subscribed_retainInfo eventBus error')
            }
        }
    }

    handleToggleSubscribed() {
        this.setState({isLectureSubscribed: !this.state.isLectureSubscribed})
    }

    hide() {
        this.setState({show: false})
        this.ticks && clearInterval(this.ticks)

        const {isLectureSubscribed} = this.state
        const {lecture, subscribed, channelSubscribed} = this.props
        if (isLectureSubscribed && !subscribed && !channelSubscribed) {
            axios.post(`/api/lecture/${lecture.id}/subscribe`).then(res => {});
        }
    }

    componentWillMount() {
        const {lecture, role} = this.props
        const tsNow = parseInt(Date.now() / 1000, 10)
        if (lecture.start_timestamp > tsNow && !role.is_manager) {
            this.ticks = setInterval(() => {
                this.updateCountDown()
            }, 1000)
            this.updateCountDown()
            this.setState({started: false, show: true})
        } else {
            this.setState({started: true})
        }
    }

    updateCountDown() {
        const {lecture} = this.props
        const tsNow = parseInt(Date.now() / 1000, 10)
        const delta = lecture.start_timestamp - tsNow
        if (delta >= 0) {
            let tmp = delta
            let seconds = tmp % 60;
            tmp = (tmp - seconds) / 60;

            let minutes = tmp % 60;
            tmp = (tmp - minutes) / 60;

            let hours = tmp % 24;
            let days = (tmp - hours) / 24;

            if (seconds < 10)
                seconds = '0' + seconds.toString()
            if (minutes < 10)
                minutes = '0' + minutes.toString()
            if (hours < 10)
                hours = '0' + hours.toString()

            this.setState({
                countdown: {
                    seconds: seconds,
                    minutes: minutes,
                    hours: hours,
                    days: days
                }
            })
        } else {
            this.hide()
        }
    }

    componentWillUnmount() {
        this.ticks && clearInterval(this.ticks)
        EventBus.off('subscribed_retainInfo')
    }

    render() {
        if (!this.state.init) {
            return null
        }

        if (this.state.isSubscribedTOtherAccount) {
            return null
        }
        const {buttons, show, countdown, isLectureSubscribed, deepperFocusQrcode} = this.state
        const {qrcodes, account, subscribed, channelSubscribed} = this.props
        return <WKOwnDialog title="距离课堂开始还有" type="ios" buttons={buttons} show={show} className="countdown">
            <p style={{color: '#02BB00',fontSize: '16px',letterSpacing: '1px', mariginBottom: '10px'}}>
                {countdown.days}天&nbsp;{countdown.hours}时&nbsp;{countdown.minutes}分&nbsp;{countdown.seconds}秒
            </p>

            {!account.subscribed &&
            <div>
                <p className="content__qrcode">
                    <img className="qrcode-img" src={qr(deepperFocusQrcode)} alt="qrcode"/>
                </p>
                <p style={{marginTop: '5px'}}>长按扫码，课程开始时通知你</p>
            </div>
            }

            {!subscribed && !channelSubscribed && account.subscribed &&
            <Form checkbox>
                <FormCell checkbox className="lecture-subscribed">
                    <CellHeader>
                        <Checkbox name="checkbox1" onChange={this.handleToggleSubscribed} checked={isLectureSubscribed && "checked"} value="1"/>
                    </CellHeader>
                    <CellBody><span style={{fontSize: '12px'}}>预约课程，课程开始时通知你</span></CellBody>
                </FormCell>
            </Form>
            }
        </WKOwnDialog>
    }
}


export default connect((state) => ({
    lecture: state.classroom.lecture,
    liveroom: state.classroom.liveroom,
    qrcodes: state.classroom.qrcodes,
    account: state.account,
    subscribed: state.classroom.lecture_access.subscribed,
    channelSubscribed: state.classroom.channel_access && state.classroom.channel_access.subscribed || false,
    role: state.classroom.role,
}))(ClassroomCountDown)




// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomCountDown.js